import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.messaging.chat;

const getChatInfo = createSelector(getData, info => info);

export default getChatInfo;



// WEBPACK FOOTER //
// ./src/_selectors/messagingSelectors/getChatInfo.js